import { PollingStatus, StatusProvider } from '@/tax/models';

export type ProgressModel = { progress: number };

export enum SyncEntityType {
    ExactOnline = 'ExactOnline',
    Yuki = 'Yuki',
}

export const InvoiceSortBy = {
    OpenAmount: 'open_amount',
    CustomerSupplierName: 'customer_supplier_name',
    OpenInvoiceCount: 'open_invoice_count',
    CustomerSupplierInvoiceNr: 'customer_supplier_invoice_nr',
    Date: 'date',
} as const;

export type InvoiceSortBy = (typeof InvoiceSortBy)[keyof typeof InvoiceSortBy];

export const InvoiceSortDirection = {
    Asc: 'asc',
    Desc: 'desc',
} as const;

export type InvoiceSortDirection = (typeof InvoiceSortDirection)[keyof typeof InvoiceSortDirection];

export class CustomersSuppliersSync {
    id = -1;
    periodId = -1;
    accounts: number[] = [];
    syncReference = '';
    accountancySynchronisationEntityType: string = SyncEntityType.ExactOnline;
    importAttachments = false;
    importIndividualInvoices = false;
    invoiceSortBy: InvoiceSortBy = InvoiceSortBy.OpenAmount;
    invoiceSortDirection: InvoiceSortDirection = InvoiceSortDirection.Desc;
    organisationId = -1;
    companyId = -1;
    transactionAmount = -1;
    createdAt = new Date();
    endDate?: Date;
    status: PollingStatus = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;
    progress = 0;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.periodId = data.period_id ?? -1;
        this.accounts = data.accounts ?? [];
        this.syncReference = data.sync_reference ?? '';
        this.accountancySynchronisationEntityType = data.accountancy_synchronisation_entity_type ?? SyncEntityType.ExactOnline;
        this.importAttachments = data.import_attachments ?? false;
        this.importIndividualInvoices = data.import_individual_invoices ?? false;
        this.invoiceSortBy = data.invoice_sort_by ?? InvoiceSortBy.OpenAmount;
        this.invoiceSortDirection = data.invoice_sort_direction ?? InvoiceSortDirection.Desc;
        this.organisationId = data.organisation ?? -1;
        this.companyId = data.company ?? -1;
        this.transactionAmount = data.transaction_amount ?? -1;
        this.createdAt = data.created_at ?? new Date();
        this.endDate = data.end_date ?? undefined;
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        this.progress = data.progress ?? 0;
        return this;
    }

    serialize(): any {
        return {
            'period_id': this.periodId,
            accounts: this.accounts,
            'sync_reference': this.syncReference,
            'accountancy_synchronisation_entity_type': this.accountancySynchronisationEntityType,
            'import_attachments': this.importAttachments,
            'import_individual_invoices': this.importIndividualInvoices,
            'invoice_sort_by': this.invoiceSortBy,
            'invoice_sort_direction': this.invoiceSortDirection,
        };
    }
}
